// extracted by mini-css-extract-plugin
export default {"container":"Pq-z","heading":"Qq-z","text":"Rq-z","info":"Sq-z","link":"Tq-z","fullMaxWidth":"Uq-z"};